import { Component } from '@angular/core';
import { Allergens } from 'src/interfaces/enums.model';

/** Регламент (ЕС) № 1169/2011 на EUR-Lex — язык выбирается на сайте */
const REGULATION_URL = 'https://eur-lex.europa.eu/eli/reg/2011/1169/oj';

/**
 * Справочник аллергенов в конце меню, перед подвалом — как в карточке блюда и
 * напитка в приложении Edim: требование ЕС, ссылка на регламент и все 14
 */
@Component({
    selector: 'app-desktop-allergens',
    templateUrl: './desktop-allergens.component.html',
    styleUrls: ['./desktop-allergens.component.css'],
    standalone: false
})
export class DesktopAllergensComponent {
  readonly regulationUrl = REGULATION_URL;
  /** Все 14 аллергенов — в порядке Приложения II */
  readonly allergens = Object.values(Allergens).filter(
    (value): value is Allergens => typeof value === 'number' && value !== Allergens.unknown,
  );
}
